import { AnyStateWithExchange } from '../types';

export const getErrorState = (state: AnyStateWithExchange) => state.exchange.error;
